module.exports = __webpack_public_path__ + "img/智能实训-图片3.e34a8371.png";